var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('embrillianceController', ['$scope', '$rootScope', '$window', 'embrilliancePageElasticService', 'urlService', 'randomService', 'commonService', 'configs',
    function ($scope, $rootScope, $window, elasticService, urlService, randomService, commonService, configs) {

        //#region Initialization & Cart
        $scope.bxFonts = [];
        $scope.themePacks = [];
        $scope.beginnerDesigns = [];
        $scope.testimonials = [];
        $scope.bundleProduct = null;
        $scope.customerCartRS = $rootScope.customerCartRS || [];

        $scope.$watch(function () { return $rootScope.customerCartRS; }, function (newVal) {
            $scope.customerCartRS = newVal || [];
        }, true);
        //#endregion

        //#region Helpers
        var BEGINNER_PRODUCT_IDS = (window.__env && window.__env.embrillianceBeginnerProductIds && window.__env.embrillianceBeginnerProductIds.length) ? window.__env.embrillianceBeginnerProductIds : ['btl01-stitchart3', 'btl01-stitchart2', 'btl01-ehf10'];
        var EMBRILLIANCE_PRODUCT_SOURCE_INCLUDES = [
            'brand', 'catalog', 'name', 'listPrice', 'salePrice', 'clubPrice', 'itemId', 'definitionName',
            'productId', 'variants.variantId', 'variants.numberOfDesigns', 'isBuyable', 'rating', 'saleRank',
            'yearCreated', 'designKeywords'
        ];

        $scope.getLowestEmbrilliancePrice = function (source) {
            if (!source) return null;

            var candidates = [source.clubPrice, source.salePrice, source.listPrice]
                .map(function (v) { return Number(v); })
                .filter(function (v) { return !isNaN(v) && v > 0; });

            return candidates.length ? Math.min.apply(null, candidates) : null;
        };
        //#endregion

        //#region Elastic — BX Fonts (category: embrilliance starter packs, definition: FontPack)
        function getBXFonts() {
            var request = elasticService.buildEmbrillianceStarterPacksByDefinitionRequest('embrilliance starter packs', 'FontPack', 20);
            commonService.getElasticData(configs.elasticBaseUrl, request).then(
                function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits) {
                        $scope.bxFonts = randomService.getRandomItems(response.data.hits.hits.slice(), 3);
                    }
                },
                function (error) { console.error('Error fetching BX fonts:', error); }
            );
        }
        //#endregion

        //#region Elastic — Theme Packs (DesignPack) & Beginner Best Sellers (by ID)
        function getDesignProducts() {
            var request = elasticService.buildEmbrillianceStarterPacksByDefinitionRequest('embrilliance starter packs', 'DesignPack', 20);
            commonService.getElasticData(configs.elasticBaseUrl, request).then(
                function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits) {
                        $scope.themePacks = randomService.getRandomItems(response.data.hits.hits.slice(), 3);
                    }
                },
                function (error) { console.error('Error fetching design products:', error); }
            );
            getBeginnerDesignsProducts();
        }

        function getBeginnerDesignsProducts() {
            var request = elasticService.buildProductInfoRequest(BEGINNER_PRODUCT_IDS, true);
            commonService.getElasticData(configs.elasticBaseUrl, request).then(
                function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits) {
                        var hits = response.data.hits.hits;
                        var idToHit = {};
                        hits.forEach(function (h) { if (h._id) idToHit[h._id] = h; });
                        var ordered = [];
                        BEGINNER_PRODUCT_IDS.forEach(function (id) {
                            if (idToHit[id]) ordered.push(idToHit[id]);
                        });
                        $scope.beginnerDesigns = ordered;
                    }
                },
                function (error) { console.error('Error fetching Beginner-Friendly Best Sellers:', error); }
            );
        }
        //#endregion

        //#region Elastic — Starter bundle (top 1 ProjectPack)
        function getStarterBundleProduct() {
            var request = elasticService.buildEmbrillianceStarterPacksByDefinitionRequest('embrilliance starter packs', 'ProjectPack', 1);
            commonService.getElasticData(configs.elasticBaseUrl, request).then(
                function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits && response.data.hits.hits.length > 0) {
                        var hit = response.data.hits.hits[0];
                        $scope.bundleProduct = hit._source;
                        if ($scope.bundleProduct.listPrice && $scope.bundleProduct.salePrice && $scope.bundleProduct.salePrice < $scope.bundleProduct.listPrice) {
                            $scope.bundleSavings = $scope.bundleProduct.listPrice - $scope.bundleProduct.salePrice;
                        }
                    }
                },
                function (error) { console.error('Error fetching starter bundle product:', error); }
            );
        }

        $scope.getBundleProductUrl = function () {
            if (!$scope.bundleProduct || !$scope.bundleProduct.itemId) return '';
            var p = $scope.bundleProduct;
            var catalog = p.catalog || p.brand;
            var url = urlService.getProductUrl(p.definitionName, catalog, p.name, p.itemId);
            return url ? '/' + url : '';
        };

        $scope.getProductPageUrl = function (prd) {
            if (!prd || !prd._source) return '#';

            var src = prd._source;
            var productId = src.itemId || prd._id;
            if (!productId || !src.definitionName || !src.name) return '#';

            var catalog = src.catalog || src.brand;
            var url = urlService.getProductUrl(src.definitionName, catalog, src.name, productId);
            return url ? '/' + url : '#';
        };

        $scope.getEmbrillianceImageProductCode = function (prd) {
            if (!prd || !prd._source) return '';
            var src = prd._source;
            var productId = src.itemId || prd._id || src.productId;
            if (!productId) return '';

            // ecom-product-image-url expects product-code format "prefix-id"
            // and extracts the id using split('-')[1].
            if (String(productId).indexOf('-') > -1) return productId;
            return 'prd-' + productId;
        };
        //#endregion

        $scope.embrillianceNewProducts = [];
        $scope.embrillianceStarterProducts = [];

        //#region Testimonials (from window.__embrillianceTestimonials set in Liquid from locale;)
        var TESTIMONIALS_FALLBACK = [
            { rating: 5, quote: "Easy to learn and use. Highly recommend for the price.", authorName: "Sarah M." },
            { rating: 5, quote: "Purchased this software HOPING for something user friendly that would allow me to customize my designs! Price was on point and software works fantastic! AMAZING!!", authorName: "Jennifer A" },
            { rating: 5, quote: "I am new to embroidery and have tried a couple of programs but this program by far has been the simplest for me. It is easy to use and I am able to find videos to help me learn how to do a variety of projects using this software. I would highly recommend it for anyone that is beginning to do embroidery work.", authorName: "Joy C." },
            { rating: 5, quote: "I absolutely love this software! It is easy to use and just what I needed. Will upgrade as I need to, and thankful that this program is upgradeable.", authorName: "Christine B." },
            { rating: 5, quote: "This is such an easy to use, intuitive software that I can't say enough about it. I highly recommend it to anyone who does machine embroidery.", authorName: "Mary W." },
            { rating: 5, quote: "I saw so many YouTube videos on this product and many that are using it. They were not wrong. It is a wonderful program and easy for a beginner embroider like me to figure out. Embrilliance also has YouTube videos available in which I took full advantage. Thank you for such an awesome program.", authorName: "Cathy L." }
        ];

        function loadTestimonials() {
            var list = $window.__embrillianceTestimonials;
            if (typeof list === 'string') {
                try { list = JSON.parse(list); } catch (e) { list = null; }
            }
            if (!list || !Array.isArray(list) || list.length === 0) {
                list = TESTIMONIALS_FALLBACK.slice();
            }
            $scope.testimonials = list.length >= 3 ? randomService.getRandomItems(list, 3) : list;
        }
        //#endregion

        //#region Init
        $scope.init = function () {
            getBXFonts();
            getDesignProducts();
            loadTestimonials();
            getStarterBundleProduct();
        };
        $scope.init();
        //#endregion
    }
]);
